import React from 'react'
import { IconButton } from '../../buttons/IconButton/IconButton'
import { IconDigitalEdition } from '../../icons/IconDigitalEdition/IconDigitalEdition'
import { IconEmail } from '../../icons/IconEmail/IconEmail'
import { IconFacebook } from '../../icons/IconFacebook/IconFacebook'
import { IconInstagram } from '../../icons/IconInstagram/IconInstagram'
import { IconLink } from '../../icons/IconLink/IconLink'
import { IconLinkedIn } from '../../icons/IconLinkedIn/IconLinkedIn'
import { IconReddit } from '../../icons/IconReddit/IconReddit'
import { IconRSS } from '../../icons/IconRSS/IconRSS'
import { IconTwitter } from '../../icons/IconTwitter/IconTwitter'
import { IconYoutube } from '../../icons/IconYoutube/IconYoutube'
import { colors } from '../../__styling/settings/colors'
import { PixelOffset } from './IconButton.styled'

interface IconButtonProps {
    title?: string
    link: string
    className?: string
    iconScale?: number
    baseColor?: string
    onClick?: () => void
    offset?: PixelOffset
}

export const FacebookIconButton: React.FC<IconButtonProps> = (props) => (
    <IconButton
        baseColor={colors.social.facebook}
        icon={<IconFacebook title={props.title} />}
        iconScale={0.75}
        noBorder={true}
        offset={{ top: 65, left: 50 }}
        {...props}
    />
)

export const TwitterIconButton: React.FC<IconButtonProps> = (props) => (
    <IconButton
        baseColor={colors.social.twitter}
        icon={<IconTwitter title={props.title} />}
        iconScale={0.62}
        {...props}
    />
)

export const InstagramIconButton: React.FC<IconButtonProps> = (props) => (
    <IconButton
        baseColor={colors.social.instagram}
        icon={<IconInstagram title={props.title} />}
        iconScale={0.63}
        {...props}
    />
)

export const YoutubeIconButton: React.FC<IconButtonProps> = (props) => (
    <IconButton
        baseColor={colors.social.youtube}
        icon={<IconYoutube title={props.title} />}
        iconScale={0.63}
        {...props}
    />
)

export const RSSIconButton: React.FC<IconButtonProps> = (props) => (
    <IconButton
        useAnchorTag={true}
        baseColor={colors.social.rss}
        icon={<IconRSS title={props.title} />}
        iconScale={0.6}
        {...props}
    />
)

export const DigitalEditionIconButton: React.FC<IconButtonProps> = (props) => (
    <IconButton
        useAnchorTag={true}
        baseColor={colors.social.rss}
        icon={<IconDigitalEdition title={props.title} />}
        iconScale={0.6}
        onClick={props.onClick}
        {...props}
    />
)

export const RedditIconButton: React.FC<IconButtonProps> = (props) => (
    <IconButton
        baseColor={colors.social.reddit}
        icon={<IconReddit title={props.title} />}
        {...props}
    />
)

export const LinkIconButton: React.FC<IconButtonProps> = (props) => (
    <IconButton
        baseColor={colors.social.clipboard}
        icon={<IconLink title={props.title} />}
        iconScale={0.6}
        {...props}
    />
)

export const EmailIconButton: React.FC<IconButtonProps> = (props) => (
    <IconButton
        baseColor={colors.social.email}
        icon={<IconEmail title={props.title} />}
        iconScale={0.61}
        {...props}
    />
)

export const LinkedInIconButton: React.FC<IconButtonProps> = (props) => (
    <IconButton
        baseColor={colors.social.linkedIn}
        icon={<IconLinkedIn title={props.title} />}
        iconScale={0.61}
        {...props}
    />
)
